import Image from "next/image";
import styled from "styled-components";

export const ShareContainer = styled.div`
    display: flex;
    gap: 1rem;
`;

export const InstagramButton = styled.a`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    background: #e1306c;
    color: white;
    cursor: pointer;
    &:hover {
        opacity: 0.8;
    }
`;

export const Icon = styled(Image)`
    width: 2rem;
    height: 2rem;
`;
